import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BarrierBlockIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-barrier-block",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 7m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v7a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 16v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7.5 16l9 -9"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13.5 16l6.5 -6.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 13.5l6.5 -6.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 16v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5 20h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15 20h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 7v-2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 7v-2"
    }, null), _createTextVNode(" ")]);
  }
};